import React from 'react';
import { requestUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const RequestAction = ({ code, disabled }) => (
  <RibbonMenu
    name="request"
    icon="key"
    message="tabs.request"
    url={requestUrl({ code }, '#')}
    className="aridhia-request-action"
    disabled={disabled}
  />
);

export default RequestAction;
